








import { Component, Vue } from 'vue-property-decorator';
import NavBar from '@/components/NavBar.vue';
import BrowserAlert from '@/components/BrowserAlert.vue';


@Component({
    components: {
        NavBar,
        BrowserAlert
    }
})
export default class Layout extends Vue {
}
